// 链接source参数
export const BASE_URL_SOURCE = (() => {
  const match = window.location.href.match(/[?&]source=([^&]+)/);
  return match ? decodeURIComponent(match[1]) : "";
})();

// 链接前缀
export const BASE_URL = `https://${import.meta.env.VITE_APP_CURENV === "production" ? "h5" : "qtest"}.hellotalk8.com`;

// deep link 链接
export const MY_NAMEPLATE = `${BASE_URL}/commercial/wear-logo?HA=1&HS=1&tab=1&entrance=${BASE_URL_SOURCE}`; // 我的铭牌
export const MOMENT_PROMOTE = `hellotalk://momentPromote/experienceCard?source=${BASE_URL_SOURCE}`; // 帖文推广
export const SUPER_BOOST = `hellotalk://boost?source=${BASE_URL_SOURCE}`; // 超级曝光
